import { render, staticRenderFns } from "./CoronaResponseResult.vue?vue&type=template&id=3c489236&scoped=true"
import script from "./CoronaResponseResult.vue?vue&type=script&lang=js"
export * from "./CoronaResponseResult.vue?vue&type=script&lang=js"
import style0 from "./CoronaResponseResult.vue?vue&type=style&index=0&id=3c489236&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c489236",
  null
  
)

export default component.exports